export default {
  FREE: 'free',
  TRIAL: 'trial',
  SIGNATURE: 'signature',
};
